import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getConnections(gid, caseNumber, caseType) {
  return fetch(
    `${endpoints.connection}/?caseNumber=${encodeURIComponent(caseNumber)}&entityType=${caseType}&gid=${gid}`,
    {
      ...(await getHeader('GET'))
    }
  ).then(parseResponse);
}
